import { MdInfoOutline } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { TScore } from '~/types/cluster'

import Tooltip from '~/components/Tooltip'

import './styles.scss'

const getColor = (value: number) =>
  value <= 0 ? '#FF2E26' : value <= 7 ? '#F7A23B' : value <= 14 ? '#FBC62F' : '#0FCA7A'

const getPercentScoreColor = (value: number) =>
  value <= 25 ? '#FF2E26' : value <= 50 ? '#F7A23B' : value <= 75 ? '#FBC62F' : '#0FCA7A'

export interface Props {
  cellScore: TScore
  scale?: 25 | 100
  tooltipScores?: TScore[]
}

const ClusterScore = ({ cellScore, scale = 25, tooltipScores }: Props): ReactElement | null => {
  return (
    <div className="cluster-score-component">
      <span
        className="cluster-score-component__main-score"
        style={{
          color:
            cellScore.value !== null
              ? scale === 25
                ? getColor(cellScore.value)
                : getPercentScoreColor(cellScore.value)
              : '#000',
        }}
      >
        {cellScore.value !== null ? cellScore.value : '?'}
        {cellScore.unit}
      </span>
      {tooltipScores && tooltipScores.length > 0 ? (
        <Tooltip
          className="cluster-score-component__tooltip"
          overlay={
            <ul>
              {tooltipScores.map(({ label, value }, idx) => (
                <li className="cluster-score-component__score-item" key={idx}>
                  {label}: <span className="cluster-score-component__tooltip-score-item__value">{value}</span>
                </li>
              ))}
            </ul>
          }
          placement="top"
          trigger="hover"
        >
          <div className="cluster-score-component__info-icon-wrapper">
            <MdInfoOutline color="#aeaeae" size={13} />
          </div>
        </Tooltip>
      ) : null}
    </div>
  )
}

export default ClusterScore
